<script setup>
const props = defineProps({
    items: {
        type: Array,
        default: () => [],
    },
    rewardData: {
        type: Object,
        default: () => ({}),
    },
});
</script>

<template>
    <div v-if="items.length" class="present-cards-cont">
        <p class="present-cards-cont__title">Выберите подарок при оформлении заказа:</p>

        <!-- Показываем заголовок и только одну фотку подарка.
             Карточки-подарки скрыты (см. закомментированный блок ниже, если нужно вернуть). -->
        <div class="present-cards-cont__items">
            <div class="present-img">
                <img src="/img/product/present.png" alt="Подарки" />
            </div>

            <!--
            <div
                v-for="item in items"
                :key="item.id"
                class="present-card"
            >
                <div :class="['present-card__head', item.name ? `present-card__head--${item.name}` : '']">
                    <p v-if="item.isPackage" class="present-card__head-title">
                        {{ item.title }}
                    </p>

                    <div v-else-if="item.img" class="present-card__img">
                        <img :src="item.img" :alt="item.title" />
                    </div>

                    <p v-else class="present-card__head-title present-card__head-title--dark">
                        {{ item.title }}
                    </p>
                </div>

                <div class="present-card__body">
                    <p class="present-card__title">{{ item.title }}</p>
                </div>
            </div>
            -->
        </div>
    </div>
</template>

<style lang="scss">
@import 'resources/sass/variables';

.present-cards-cont {
    margin: 8px 0 24px;

    &__title {
        margin-bottom: 10px;
        font-size: 15px;
        font-weight: 400;
        line-height: 22px;
    }

    &__items {
        gap: 12px;
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        padding-bottom: 6px;

        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background: #CDCDCD;
            border-radius: 2px;
        }
    }
}

.present-img {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 112px;
    height: 112px;

    img {
        display: block;
        height: 100%;
    }
}

.present-card {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    width: 112px;
    height: 112px;
    cursor: default;
    border-radius: 8px;
    border: 1px solid #CDCDCD;
    overflow: hidden;
    transition: .2s ease;

    &__head {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;

        &--bereket {
            background: linear-gradient(110.82deg, #FFA83F 3.29%, #FFD17A 97.37%);
        }

        &--keremet-mobile {
            background: #4DCC93;
        }

        &--keremet-tv {
            background: linear-gradient(110.82deg, #3EA5DC 3.29%, #7CBEE1 97.37%);
        }
    }

    &__head-title {
        max-width: 116px;
        font-size: 16px;
        line-height: 18px;
        font-weight: $font-weight-bold;
        text-align: center;
        color: white;

        &--dark {
            color: #222;
        }
    }

    &__body {
        padding: 6px 8px;
        background: #F8F8F8;
    }

    &__title {
        font-size: 12px;
        color: $black;
        font-weight: $font-weight-bold;
        line-height: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: $blue;

        img {
            display: block;
            width: 24px;
            height: 24px;
            object-fit: contain;
        }
    }

}
</style>
